<ng-container *transloco="let t">
  <div class="flex flex-col -m-6">
    <div class="flex flex-0 sticky -top-6 z-50 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
      <div class="text-lg font-medium">{{ 'services.dialog.cancelTask.title' | transloco }}</div>
    </div>

    <div class="w-full flex flex-col p-8">
      <div class="text-lg font-medium p-2">{{ 'services.taskPlanning.tasksToCancel' | transloco}}: {{tasksToCancel.length + tasksCantCancel.length}}</div>
      <div class="text-lg font-medium p-2">{{ 'services.taskPlanning.tasksCanCancel' | transloco}}: {{tasksToCancel.length}}</div>
      @if (tasksCantCancel.length > 0) {
        <div class="text-lg font-medium p-2">
          {{ 'services.taskPlanning.tasksCantCancel' | transloco}}: {{idsCantCancel}}
        </div>
      }
      <mat-form-field class="fuse-mat-no-subscript p-2 mt-4">
        <mat-select [formControl]="control" [placeholder]="t('selectCancelReason')" required>
          @for (option of reasonsData; track option) {
            <mat-option [value]="option.code">
              {{ option.description | localize }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if (control.touched && control.errors?.required) {
        <mat-error class="ml-3">
          {{ 'errorRequiredField' | transloco }}
        </mat-error>
      }
      <div class="flex flex-row justify-end pt-4">
        <button mat-flat-button class="mr-8" color="warn" (click)="saveReason('cancel')">{{ 'cancel' | transloco }}</button>
        <button mat-flat-button class="mr-8" color="primary" (click)="saveReason('save')">{{ 'save' | transloco }}</button>
      </div>
    </div>

  </div>
</ng-container>
